.#{$prefix}youtube-wrapper {
  iframe {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    &.hide-controls {
      pointer-events: none;
      position: absolute;
    }
  }
}
